module.exports = __webpack_public_path__ + "media/images/img-eatout-4-e729f20c.jpg";